export class QuoteDiscountDocumentViewModel {
  constructor(item) {
    if (item) {
      this.documentationFileKey = item.documentationFileKey;
      this.documentationFileName = item.documentationFileName;
      return;
    }
    this.documentationFileKey = '';
    this.documentationFileName = '';
  }
}
